import {createInfinityClient} from '@pexip/infinity';

import {callSignals} from '../signals/Call.signals';
import {infinityClientSignals} from '../signals/InfinityClient.signals';

export const infinityService = createInfinityClient(
    infinityClientSignals,
    callSignals,
);
